//@flow
import ActionTypes from './ActionTypes';
import Dispatcher from './../../../app/Dispatcher';
import {
  Notification
} from './Notification';


const Actions = {
  pushNotification(n: Notification) {
    // console.log('push notification')
    setTimeout(function() {
      Dispatcher.dispatch({
        type: ActionTypes.PUSH_NOTIFICATION,
        notification: n
      });
    }, 3);

    setTimeout(function() {
      Dispatcher.dispatch({
        type: ActionTypes.DROP_NOTIFICATION,
        id: n.getId()
      });
    }, 12000);

  },
  dropNotification(id: string) {
    // console.log('drop notification')
    Dispatcher.dispatch({
      type: ActionTypes.DROP_NOTIFICATION,
      id: id
    });
  }
}

export default Actions;